export const types = {
  PREFILL_QUOTES_REQUEST: 'PREFILL_QUOTES_REQUEST',
  PREFILL_QUOTES_SUCCESS: 'PREFILL_QUOTES_SUCCESS',
  PREFILL_QUOTES_FAILURE: 'PREFILL_QUOTES_FAILURE',
};

export const prefillQuotesRequest = (
  customerFiscalNumber,
  shouldRedirect,
  business,
) => ({
  type: types.PREFILL_QUOTES_REQUEST,
  payload: { customerFiscalNumber, shouldRedirect },
  business,
});

export const prefillQuotesSuccess = state => ({
  type: types.PREFILL_QUOTES_SUCCESS,
  payload: { state },
});

export const prefillQuotesFailure = payload => ({
  type: types.PREFILL_QUOTES_FAILURE,
  payload,
});
